import { __rest, __read, __awaiter, __generator, __assign } from 'tslib';
import { jsx } from '@emotion/react/jsx-runtime';
import { useState, useMemo } from 'react';
import useDebounce from '../node_modules/use-debounce/esm/useDebounce.js';
import useDebouncedCallback from '../node_modules/use-debounce/esm/useDebouncedCallback.js';
import cuid from 'cuid';
import { FormField } from '../FormField/FormField.js';
import { ComboBox } from './components/ComboBox.js';
import { flattenSuggestions, checkIsGroup } from './utils/Utils.js';
import { useUpdateEffect } from '../hooks/useUpdateEffect/index.js';
import { Section, Item } from 'react-stately';
export { Item } from 'react-stately';

var Typeahead = function (_a) {
    var _b = _a.debounceDuration, debounceDuration = _b === void 0 ? 500 : _b, _c = _a.id, id = _c === void 0 ? cuid() : _c, _d = _a.isLoading, isLoading = _d === void 0 ? false : _d, _e = _a.disabled, disabled = _e === void 0 ? false : _e, _f = _a.minLength, minLength = _f === void 0 ? 3 : _f, _g = _a.size, size = _g === void 0 ? "md" : _g, defaultValue = _a.defaultValue, onChange = _a.onChange, onAsyncChange = _a.onAsyncChange, onSelect = _a.onSelect, suggestions = _a.suggestions, value = _a.value, 
    // formField
    optional = _a.optional, error = _a.error, label = _a.label, hint = _a.hint, subCopy = _a.subCopy, info = _a.info, props = __rest(_a, ["debounceDuration", "id", "isLoading", "disabled", "minLength", "size", "defaultValue", "onChange", "onAsyncChange", "onSelect", "suggestions", "value", "optional", "error", "label", "hint", "subCopy", "info"]);
    var menuTriggerAction = "input";
    var _h = __read(useState(defaultValue || ""), 2), filterText = _h[0], setFilterText = _h[1];
    var _j = __read(useDebounce(filterText, debounceDuration), 1), filterTextDebounced = _j[0];
    var inputValue = value || filterText;
    var debouncedOnInputChange = useDebouncedCallback(function (newValue) {
        onChange === null || onChange === void 0 ? void 0 : onChange(newValue);
    }, debounceDuration);
    var handleInputChange = function (newValue) {
        setFilterText(newValue);
        debouncedOnInputChange(newValue);
    };
    var _k = __read(useState(suggestions || []), 2), list = _k[0], setList = _k[1];
    useUpdateEffect(function () {
        if (onAsyncChange) {
            (function () { return __awaiter(void 0, void 0, void 0, function () {
                var results;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, onAsyncChange(filterTextDebounced)];
                        case 1:
                            results = _a.sent();
                            if (results) {
                                setList(results);
                            }
                            return [2 /*return*/];
                    }
                });
            }); })();
        }
    }, [filterTextDebounced]);
    var items = useMemo(function () { return list && flattenSuggestions(list); }, [list]);
    var handleOnSelect = function (newValue) {
        var option = (items === null || items === void 0 ? void 0 : items.find(function (item) { return item.value === newValue; })) || null;
        onSelect === null || onSelect === void 0 ? void 0 : onSelect(option);
    };
    var formFieldProps = {
        optional: optional,
        error: error,
        hint: hint,
        label: label,
        subCopy: subCopy,
        info: info,
        size: size,
        fieldId: id,
    };
    return (jsx(FormField, __assign({}, formFieldProps, { children: jsx(ComboBox, __assign({ id: id, label: label, defaultInputValue: defaultValue, defaultSelectedKey: defaultValue, inputValue: inputValue, isDisabled: disabled, isLoading: isLoading, minLength: minLength, onInputChange: handleInputChange, onSelectionChange: handleOnSelect, menuTrigger: menuTriggerAction, optional: optional, size: size, allowsCustomValue: true, error: Boolean(error), isAsync: Boolean(onAsyncChange) }, props, { children: (list === null || list === void 0 ? void 0 : list.length) ? (list.map(function (suggestion) {
                return checkIsGroup(suggestion) && suggestion.options ? (jsx(Section, __assign({ title: suggestion.title }, { children: suggestion.options.map(function (option) { return (jsx(Item, __assign({ textValue: option.value }, { children: option.label }), option.value)); }) }), suggestion.title)) : (jsx(Item, __assign({ textValue: suggestion.value }, { children: suggestion.label }), suggestion.value));
            })) : (jsx(Item, __assign({ textValue: "nothing" }, { children: "Type something to get results" }))) })) })));
};
Typeahead.displayName = "Typeahead";

export { Typeahead };
//# sourceMappingURL=Typeahead.js.map
